var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLofiPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3033_8574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 20.3967C17.6201 20.4019 17.6201 20.407 17.6201 20.4122H1.16884C1.15522 20.4042 1.15052 20.3963 1.15428 20.3874C0.842976 20.3724 0.757051 20.2964 0.652344 19.9908V19.6627C0.805413 19.208 1.08338 18.819 1.31815 18.4079C2.68419 16.0173 4.05118 13.6268 5.4191 11.2362C6.72817 8.9494 8.03741 6.66196 9.34679 4.3739C9.44868 4.19578 9.58767 4.07203 9.79285 4.03125H10.0746C10.3023 4.07812 10.4277 4.22671 10.5277 4.4264C13.0263 9.42626 15.5289 14.4252 18.0356 19.4232C18.0567 19.4649 18.0783 19.5061 18.0962 19.5497C18.2685 19.9753 18.0178 20.4075 17.6201 20.3967Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.681 20.3675C19.2692 19.557 18.8542 18.7489 18.4466 17.9366C17.264 15.5798 16.0818 13.2225 14.9002 10.8648C14.8335 10.7326 14.8297 10.6435 14.9246 10.516C15.6359 9.55934 16.336 8.59421 17.0413 7.63236C17.393 7.15284 17.8165 7.17768 18.0982 7.69423C20.2715 11.6744 22.4439 15.6549 24.6154 19.6358C24.6215 19.6466 24.6393 19.6517 24.6516 19.6592V19.9873C24.5379 20.3154 24.4464 20.3797 24.0632 20.3843C22.6859 20.3843 21.3098 20.3843 19.935 20.3843C19.8505 20.3825 19.7641 20.3975 19.681 20.3675Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6806 20.3672L24.1375 20.3695C24.1511 20.3784 24.1553 20.3873 24.1502 20.3953C24.145 20.4033 24.1403 20.4075 24.1351 20.4075H19.6825C19.6795 20.3943 19.6789 20.3806 19.6806 20.3672Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3033_8574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.381,
    fill: "white",
    transform: "translate(0.652344 4.03125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLofiPlaylist);
export default __webpack_public_path__ + "static/media/lofi-playlist.3c53916f8047cfcfdca03c5a59473eb8.svg";
export { ForwardRef as ReactComponent };